<template>
    <v-card>
        <v-card-title>
            Dodaj ofertę
        </v-card-title>
        <v-card-text>
            <v-form ref="addOfferForm" :disabled="inProgress">
                <v-row>
                    <v-col>
                        <v-radio-group v-model="type" row mandatory>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-radio
                                            label="Wystaw w imieniu klienta"
                                            :value="1"
                                        />
                                    </div>
                                </template>
                                Oferta zostanie przypisana do wskazanego konta email.<br>
                                Otrzyma status "oczekująca na weryfikację" (pending).<br>
                                W celu aktywowania oferty klient będzie musiał kliknąć link otrzymany w wiadomości
                                SMS.<br>
                                Link ten odnotuje również na jego koncie fakt akceptacji regulaminu i polityki
                                prywatności.
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                        <v-radio
                                            label="Wystaw jako Przekazana do Partnera"
                                            :value="2"
                                        />
                                    </div>
                                </template>
                                Oferta zostanie przypisana do głównego konta administracyjnego.<br>
                                Otrzyma również specjalny status umożliwiający odfiltrowanie jej w Panelu Admina.<br>
                                Nie będzie można dodawać do niej ofert kupna.
                            </v-tooltip>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-autocomplete
                            v-model="offer.categoryId"
                            :loading="loading"
                            :items="categoryAutoComplete.items"
                            :search-input.sync="categoryQuery"
                            cache-items
                            item-text="name"
                            item-value="id"
                            flat
                            hide-no-data
                            label="Kategoria"
                            :rules="rules.categoryFilter"
                        >
                            <template v-slot:item="{ item }">
                                <div class="category-autocomplete-item">
                                    <div>
                                        <h4 class="name">{{ item.text }}</h4>
                                        <h5 class="breadcrumb">{{ item.breadcrumb }}</h5>
                                    </div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.quantity"
                            :disabled="!offer.categoryId"
                            placeholder="Ilość"
                            aria-valuemin="1"
                            :rules="rules.quantityFilter"
                        >
                            <template v-slot:append-outer>
                                {{ category.unit }}
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.city"
                            label="Miejscowość"
                            placeholder=" "
                            :counter="100"
                            :rules="rules.cityFilter"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.postalCode"
                            label="Kod pocztowy"
                            placeholder=" "
                            :counter="10"
                            :rules="rules.postalCodeFilter"
                        />
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="offer.region"
                            label="Województwo"
                            :items="regions"
                            item-value="value"
                            item-text="text"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            v-model="description"
                            label="Opis oferty"
                            placeholder=" "
                            :counter="2000"
                            rows="3"
                        />
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="offer.companyType"
                            label="Typ konta"
                            placeholder=" "
                            :items="companyTypes"
                            item-value="value"
                            item-text="text"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.companyName"
                            :disabled="'N' === offer.companyType"
                            label="Nazwa firmy"
                            placeholder=" "
                            :counter="100"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.email"
                            label="Email"
                            placeholder=" "
                            :aria-required="true"
                            :counter="254"
                            :rules="rules.emailFilter"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="offer.phone"
                            label="Telefon"
                            placeholder=" "
                            :counter="20"
                            :rules="rules.phoneFilter"
                        />
                    </v-col>
                    <v-col>

                    </v-col>
                </v-row>
                <v-row>
                  <vue-dropzone id="dropzone" :options="dropzoneOptions" class="mt-4"
                                v-on:vdropzone-success="storeImageId"
                                v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                </v-row>
                <v-row>
                    <v-col class="text-center">
                        <v-btn :disabled="inProgress" @click="proceed">
                            Wystaw
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
            <span v-if="link">
              Link:
              <a target="_blank" :href="link">
                {{ link }}
              </a>
            </span>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/services/api";
import {getItems as getRegionItems} from "@/enums/RegionCode";
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "@/services/Auth";

export default {
    components: {
      vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            loading: false,
            inProgress: false, // Account & sale offer creation is in progress.

            categories: [],
            mappedCategories: {},
            regions: [
                ...getRegionItems(),
            ],
            dropzoneOptions: {
              paramName: 'photo',
              url: `${process.env.VUE_APP_API_URL}/api/photos`,
              thumbnailWidth: 150,
              maxFilesize: 1024 * 20,
              maxFiles: 10,
              acceptedFiles: 'image/*',
              addRemoveLinks: true,
              headers: {
                'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
              }
            },
            companyTypes: [
                {
                    value: 'N',
                    text: 'Osoba fizyczna',
                },
                {
                    value: 'E',
                    text: 'Firma (wytwarzający)',
                },
            ],

            type: 1,

            // Category autocomplete.
            categoryAutoComplete: {
                loading: false,
                items: [],
            },
            categoryQuery: null,

            select: null,

            descriptionPerType: {
                1: '',
                2: 'Ta oferta została przekazana do naszego partnera. ' +
                    'Jeśli chcesz zostać jednym z naszych partnerów i ' +
                    'otrzymywać oferty odpadów bezpośrednio od WasteMaster, ' +
                    'skontaktuj się z nami i poznaj szczegóły - 796 440 881',
            },

            offer: {
                categoryId: null,
                quantity: null,
                city: null,
                postalCode: null,
                region: '',
                description: null,
                photosIds: [],
                companyType: 'N',
                companyName: null,
                email: null,
                phone: null,
                handedOverToPartner: false,
            },

            rules: {
                categoryFilter: [
                    () => {
                        if (this.offer.categoryId) {
                            return true;
                        }

                        return 'Wybierz kategorię.';
                    },
                ],
                quantityFilter: [
                    (value) => {
                        if (!this.offer.categoryId) {
                            return true; // Don't bother user if the category is not selected yet.
                        }

                        if (value) {
                            const number = parseFloat(value) || NaN;

                            if (!isNaN(number) && number >= 1) {
                                return true;
                            }
                        }

                        return 'Wpisz co najmniej jedną cyfrę większą niż 0.';
                    },
                ],
                cityFilter: [
                    (value) => {
                        if (value && value.length) {
                            return true;
                        }

                        return 'Wpisz miejscowość.';
                    },
                ],
                postalCodeFilter: [
                    (value) => {
                        if (value && value.length) {
                            return true;
                        }

                        return 'Wpisz kod pocztowy.';
                    },
                ],
                regionFilter: [
                    (value) => {
                        if (value) {
                            return true;
                        }

                        return 'Wybierz region.';
                    },
                ],
                emailFilter: [
                    (value) => {
                        if (value && value.length >= 6) {
                            return true;
                        }

                        return 'Wpisz co najmniej 6 znaków.';
                    },
                ],
                phoneFilter: [
                    (value) => {
                        if (2 === this.type) {
                            return true;
                        }

                        if (value && value.length >= 9) {
                            return true;
                        }

                        return 'Numer telefonu powinien mieć conajmniej 9 cyfr.';
                    },
                ],
            },

            jwtTokenPair: null,
            userId: null,
            link: null,
        };
    },
    mounted() {
        this.fetchAllCategories();
    },
    computed: {
        // Selected category.
        category() {
            if (!this.offer.categoryId) {
                return {};
            }

            return this.mappedCategories[this.offer.categoryId] || {};
        },

        description: {
            get: function () {
                if (!this.offer.description) {
                    return this.descriptionPerType[this.type];
                }

                return this.offer.description;
            },

            set: function (newValue) {
                this.offer.description = newValue;
            },
        }
    },
    watch: {
        categoryQuery(value) {
            this.filterCategories(value);
        },
    },
    methods: {
        storeImageId(event, image) {
          this.offer.photosIds.push(image.id);
        },
        removeImage(image) {
          this.offer.photosIds = this.photosIds.photosIds.filter(photo => photo !== image.id);
        },
        fetchAllCategories() {
            if (this.categoryAutoComplete.loading || this.categories.length) {
                return;
            }

            this.categoryAutoComplete.loading = true;
            api.get('/api/categories')
                .then((response) => {
                    const mappedCategories = {};
                    const categories = response.data.categories;

                    categories.forEach((category) => {
                        mappedCategories[category.id] = category;
                    });
                    this.categories = categories;
                    this.mappedCategories = mappedCategories;
                })
                .catch((e) => {
                    console.error('Error:', e);
                })
                .finally(() => {
                    this.categoryAutoComplete.loading = false;
                });
        },
        filterCategories(query) {
            this.categoryAutoComplete.loading = true;
            query = query.toLowerCase().trim();
            const categories = this.categories;
            const mappedCategories = this.mappedCategories;
            const items = [];
            let category, codes, parent, text, breadcrumb;

            for (let i = 0; i < categories.length; i++) {
                category = categories[i];
                codes = category.codes.join(', ').trim();

                if (category.name.toLowerCase().trim().includes(query) ||
                    codes.includes(query)
                ) {
                    parent = category.parentId
                        ? mappedCategories[category.parentId]
                        : null;
                    text = category.name;

                    if (category.requirePhoto) {
                        text += ' (WYMAGA ZDJĘCIA)';
                    }

                    breadcrumb = '';

                    if (parent) {
                        const parentCategoryName = String(parent.name).trim();

                        if ('' !== parentCategoryName) {
                            breadcrumb = `W kategorii: ${parentCategoryName}`;
                        }
                    }

                    items.push({
                        id: category.id,
                        name: category.name,
                        text: text,
                        codes: codes,
                        parentId: category.parentId,
                        parent: parent
                            ? {
                                id: parent.id,
                                name: parent.name,
                            }
                            : null,
                        unit: category.unit,
                        slug: category.slug,
                        breadcrumb: breadcrumb,
                    });
                }
            }

            this.categoryAutoComplete.items = items;
            this.categoryAutoComplete.loading = false;
        },
        proceed() {
            if (this.loading || this.inProgress) {
                return;
            }

            if (this.category && this.category.requirePhoto) {
                this.$root.$emit('notifyError', {
                    html: 'Ta kategoria wymaga dodania zdjęcia.',
                });

                return;
            }

            if (!this.$refs.addOfferForm.validate()) {
                return;
            }

            this.inProgress = true;
            this.checkAccountExistence();
        },
        checkAccountExistence() {
            api
                .post('/api/account/exists', {
                    email: this.offer.email,
                }, {
                    headers: {
                        //'Content-Type': 'application/json',
                        'X-Requested-With': 'WM Landing-Page'
                    }
                })
                .then((response) => {
                    if (200 === response.status) {
                        // Account already exists. The process cannot be continued.
                        this.addOffer(true);
                        this.inProgress = false;

                        return;
                    }

                    this.$root.$emit('notifyError', {
                        html: `Oczekiwano odpowiedzi "404 Not Found", ale serwer zwrócił kod: ${response.status} ${response.statusText}.`,
                    });
                    this.inProgress = false;
                })
                .catch((e) => {
                    console.error('Error:', e);
                    const response = e.response;

                    if (404 === response.status) {
                        // Account does NOT exists.

                        this.createAccount();

                        return;
                    }

                    this.$root.$emit('notifyError', {
                        html: `Oczekiwano odpowiedzi "404 Not Found", ale serwer zwrócił kod: ${response.status} ${response.statusText}.`,
                    });
                    this.inProgress = false;
                });
        },
        createAccount() {
            const offer = this.offer;

            api
                .post('/api/auth/register', {
                    company: {
                        name: '' !== offer.companyName ? offer.companyName : undefined,
                        //nip: undefined,
                        type: offer.companyType || 'N',
                        //naturalPerson: false, // This property probably no longer exists.
                        //address: {},
                    },
                    user: {
                        email: offer.email,
                        phone: offer.phone,
                        //name: offer.name,
                        //surname: offer.surname,
                        password: null,//temporaryPassword,
                        //tempPassword: true, // Will generate new password. Ignores the "password" field.
                    },
                }, {
                    headers: {
                        //'Content-Type': 'application/json',
                        'X-Requested-With': 'WM Landing-Page'
                    }
                })
                .then((response) => {
                    if (201 === response.status) {
                        const data = response.data;

                        this.jwtTokenPair = data.jwtTokenPair;
                        this.userId = data.id;

                        this.getAutoLoginToken();

                        return;
                    }

                    this.$root.$emit('notifyError', {
                        html: `Oczekiwano odpowiedzi "201 CREATED", ale serwer zwrócił kod: ${response.status} ${response.statusText}.`,
                    });
                    this.inProgress = false;
                })
                .catch((e) => {
                    console.error('Error:', e);

                    this.inProgress = false;
                });

        },
        getAutoLoginToken() {
            const jwtTokenPair = this.jwtTokenPair;

            api
                .get('/api/auto-login', {
                    headers: {
                        'Authorization': `Bearer ${jwtTokenPair.token}`,
                        //'Content-Type': 'application/json',
                        'X-Requested-With': 'WM Landing-Page'
                    }
                })
                .then(async (response) => {
                    if (200 === response.status) {
                        this.addOffer(false);

                        return;
                    }

                    this.$root.$emit('notifyError', {
                        html: `Oczekiwano odpowiedzi "200 OK", ale serwer zwrócił kod: ${response.status} ${response.statusText}.`,
                    });
                    this.inProgress = false;
                })
                .catch((e) => {
                    console.error('Error:', e);

                    this.inProgress = false;
                });
        },
        addOffer(asAdmin) {
            const offer = this.offer;
            const jwtTokenPair = this.jwtTokenPair;

            let headers = null;

            if (asAdmin) {
              headers = {
                'X-Requested-With': 'WM Landing-Page'
              };
            } else {
              headers = {
                'Authorization': `Bearer ${jwtTokenPair.token}`,
                //'Content-Type': 'application/json',
                'X-Requested-With': 'WM Landing-Page'
              };
            }
            api
                .post('/api/sale-offers', {
                    categoryId: offer.categoryId,
                    quantity: offer.quantity,
                    description: offer.description,
                    postalCode: offer.postalCode,
                    city: offer.city,
                    // TODO fix it
                    region: offer.region === 'SL' ? 'ŚL' : offer.region,
                    photosIds: offer.photosIds,
                    phone: offer.phone || undefined,
                    email: offer.email,

                    requireSmsConfirmation: 1 === this.type,
                    handedOverToPartner: 2 === this.type,
                }, {
                    headers: headers
                })
                .then(async (response) => {
                    if (201 === response.status) {
                        const data = response.data;

                        this.link = data.dynamicLink;
                        this.$root.$emit('notifySuccess', {
                            html: 'Oferta została utworzona.',
                        });

                        await this.$router.push({name: 'sale-offer-details', params: {id: data.id}});
                        return;
                    }

                    this.$root.$emit('notifyError', {
                        html: `Oczekiwano odpowiedzi "201 CREATED", ale serwer zwrócił kod: ${response.status} ${response.statusText}.`,
                    });
                })
                .catch((e) => {
                    console.error('Error:', e);

                })
                .finally(() => {
                    this.inProgress = false;
                });
        },
    },
}
</script>

<style>
.category-autocomplete-item .name {
    font-weight: bold;
    color: black;
    margin-bottom: 0;

    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
}

.category-autocomplete-item .breadcrumb {
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    text-decoration: none;
    color: rgba(0, 0, 0, .6);

    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
}
#dropzone {
  width: 100%;
}
</style>